import { useState } from 'react';
import Popover from '@mui/material/Popover';
import UserItem from './UserItem/UserItem';
import { ImmigrationProfessional } from 'api';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { BiTrash } from 'react-icons/bi';
import { ReactComponent as ResendEmailIcon } from 'assets/icons/resendEmail.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import * as S from './UsersListPopover.styled';

type Props = {
    currentUser: ImmigrationProfessional;
    onUser: (user: ImmigrationProfessional) => void;
    handleEditClick: (id: number) => void;
    removeItemClick: (id: number) => void;
    handleResendClick: (id: number) => void;
};

const UsersListPopover = ({
    currentUser,
    onUser,
    handleEditClick,
    removeItemClick,
    handleResendClick,
}: Props) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <>
            <S.BurgerMenu
                isActive={!!anchorEl}
                onClick={(event) => {
                    handleClick(event);
                    onUser(currentUser);
                }}
            >
                {t('selectOption', { lng: language })} <S.BurgerIcon />
            </S.BurgerMenu>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                marginThreshold={0}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            overflow: 'visible',
                            mt: '8px',
                            minWidth: '170px',
                            padding: '0',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.09)',
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                <S.DropDownMenu>
                    <UserItem
                        svgMargin={'13px'}
                        icon={EditIcon}
                        onClick={() => handleEditClick(currentUser.id)}
                    >
                        {t('editUserRole', { lng: language })}
                    </UserItem>

                    <UserItem
                        margin={'3px'}
                        svgMargin={'15px'}
                        icon={BiTrash}
                        onClick={() => removeItemClick(currentUser.id)}
                    >
                        {t('deleteUser', { lng: language })}
                    </UserItem>

                    {currentUser.status === 'INVITED' && (
                        <UserItem
                            svgMargin={'12px'}
                            icon={ResendEmailIcon}
                            onClick={() => handleResendClick(currentUser.id)}
                        >
                            {t('resendInvite', { lng: language })}
                        </UserItem>
                    )}
                </S.DropDownMenu>
            </Popover>
        </>
    );
};

export default UsersListPopover;
